import { useInfiniteQuery } from '@tanstack/react-query'
import {
  fetchApiWithToken,
  hydraNextPageParam,
  type WithHydraPagination
} from '~/api/utils'
import type { LastActivity } from '~/domains/dashboard/types'

type LastActivityLDResponse = WithHydraPagination<LastActivity>

export const useLastActivity = ({
  types,
  userIds
}: {
  types?: string[]
  userIds?: number[]
}) => {
  const queryParams = new URLSearchParams()

  if (types && types.length > 0) {
    types.forEach((type) => {
      queryParams.append('type[]', type)
    })
  }

  if (userIds && userIds.length > 0) {
    userIds.forEach((userId) => {
      queryParams.append('user_id[]', String(userId))
    })
  }

  return useInfiniteQuery<LastActivityLDResponse>({
    queryKey: ['dashboard', 'last_activity', types, userIds],
    initialPageParam: 1,
    getNextPageParam: hydraNextPageParam(),
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams(queryParams)
      params.append('page', String(pageParam))

      return await fetchApiWithToken<LastActivityLDResponse>({
        method: 'get',
        url: `/v1/last_activity?${params.toString()}`,
        useLDJson: true
      })
    },
    refetchOnWindowFocus: false,
    staleTime: 60_000
  })
}
